import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import TableCell from '../TableCell.vue';
import { TrashBinTableContentViewModel } from './trashBinTableContentViewModel';
import { i18n } from '@/i18n';
import { TableContentProperty, TrashBinHeaderKey } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TrashBinTableCell',
  props: {
    header: {},
    trashBinHeaderKey: {},
    item: {},
    headerIndex: {},
    accumulationTableContentWidth: {},
    isAllSelected: { type: Boolean },
    stableColumnCount: {},
    isChecked: { type: Boolean },
    isCheckedBusinessId: { type: Boolean }
  },
  emits: ["onClickNarrow", "onCheckboxSelected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const TrashBinTableContentVM = new TrashBinTableContentViewModel();
const t = i18n.t;

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableCell, {
    class: _normalizeClass([[_unref(TrashBinTableContentVM).isSticky(_ctx.stableColumnCount, _ctx.headerIndex) ? 'sticky-content' : ''], "table-cell base-table__body--fixed"]),
    style: _normalizeStyle({
      left: _unref(TrashBinTableContentVM).calcStickyDiff(_ctx.stableColumnCount, _ctx.headerIndex, _ctx.accumulationTableContentWidth),
    }),
    "text-align": textAlign.value,
    "table-content-property": _ctx.header,
    "tool-tip-value": _unref(TrashBinTableContentVM).displayTrashBinItem(_ctx.trashBinHeaderKey, _ctx.item),
    "is-highlighted": props.isChecked || props.isCheckedBusinessId
  }, {
    default: _withCtx(() => [
      (_ctx.trashBinHeaderKey === 'TrashBinChoice')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.item.isVirtualChild)
              ? (_openBlock(), _createBlock(RowCheckBox, {
                  key: 0,
                  "is-checked": _ctx.isChecked,
                  class: "md-primary all-check-button",
                  onChangeStatus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onCheckboxSelected', _ctx.item.displayId)))
                }, null, 8, ["is-checked"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_ctx.trashBinHeaderKey === 'TrashBinDaysRemainUntilDeletion')
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(Number(_unref(TrashBinTableContentVM).displayTrashBinItem(_ctx.trashBinHeaderKey, _ctx.item)) < 8 ? 'remainSevenDays' : ''),
              style: 'font-weight: initial;color: $semanticError;',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('onClickNarrow')))
            }, _toDisplayString(_unref(TrashBinTableContentVM).displayTrashBinItem(_ctx.trashBinHeaderKey, _ctx.item) + _unref(t)('日')), 3))
          : (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "table-cell-content",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('onClickNarrow')))
            }, _toDisplayString(_unref(TrashBinTableContentVM).displayTrashBinItem(_ctx.trashBinHeaderKey, _ctx.item)), 1))
    ], undefined, true),
    _: 1
  }, 8, ["class", "style", "text-align", "table-content-property", "tool-tip-value", "is-highlighted"]))
}
}

})